import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'sa-bonus-event-order',
  templateUrl: './bonus-event-order.component.html',
  styleUrls: ['./bonus-event-order.component.scss'],
})
export class BonusEventOrderComponent implements OnInit {
  @Input() selectedBonusEvent: any;

  constructor() {}

  ngOnInit(): void {}
}
